/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["om-profile-bubble[_ngcontent-%COMP%]{margin-right:10px}.visit-reason-text[_ngcontent-%COMP%]{margin-bottom:2rem}h5.instructions-title[_ngcontent-%COMP%]{margin-left:1.25rem;margin-right:1.25rem}div.all-instructions[_ngcontent-%COMP%]{margin-left:-1.25rem;margin-right:-1.25rem}"];
export { styles as styles };
